import { GameApi } from './game';
import { LocalStorageGameApi } from './localStorage';

export * from './game';
export const gameApi: GameApi = new LocalStorageGameApi(window.localStorage);
